import React, { useState, useEffect } from "react";
import SaveButton from "@/ui-controls/SaveButton";
import CancelButton from "@/ui-controls/CancelButton";
import { Grid } from "fluentui-react-grid";
import { User, UserModel } from "@/api/users";
import UserSelectDetailList from "@/components/users/UserSelectDetailList";
import TextInput from "@/ui-controls/TextInput";
import AddButton from "@/ui-controls/AddButton";
import { isValidateEmail } from "@/utils/StringUtils";

interface Props {
  allUsers: User[];
  nonAssignedUsers: User[];
  isSaving: boolean;
  onAddNewUser?: (user: UserModel) => any;
  onAssignUsers?: (users: User[]) => any;
  onClose?: () => any;
}

const NewUserForm = (props: Props) => {
  const [allowUserCreation] = useState<boolean>(props.onAddNewUser != null);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [selectedUsers, setSelectedUsers] = useState<User[]>([]);
  const [filteredEmailValue, setFilteredEmailValue] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    filterUsers(filteredEmailValue);
  }, [props.nonAssignedUsers]);

  const onCancelForm = () => {
    if (props.onClose) props.onClose();
  };

  const onFilter = (
    ev: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    text: string | undefined
  ) => {
    setFilteredEmailValue(text);
    filterUsers(text);
  };

  const filterUsers = (text: string | undefined) => {
    setFilteredUsers(
      text
        ? props.nonAssignedUsers.filter(
            (i) => i.EmailAddress.toLowerCase().indexOf(text) > -1
          )
        : props.nonAssignedUsers
    );
  };

  const validateEmailToAdd = (email: string | undefined) => {
    if (!email) {
      return false;
    }

    return (
      isValidateEmail(email) &&
      !props.allUsers.find(
        (i) => i.EmailAddress.toLowerCase() === email.toLowerCase()
      )
    );
  };

  const addNewUser = () => {
    if (props.onAddNewUser) {
      props.onAddNewUser({ EmailAddress: filteredEmailValue } as UserModel);
    }
  };

  const assignUsers = () => {
    if (props.onAssignUsers) {
      props.onAssignUsers(selectedUsers);
    }
  };

  return (
    <>
      <Grid dir="ltr">
        <Grid.Row>
          <Grid.Col sizeSm={12}>
            <TextInput
              label="Filter by email:"
              baseTypeProps={{
                onChange: onFilter,
              }}
            />
            {allowUserCreation && validateEmailToAdd(filteredEmailValue) ? (
              <div
                style={{
                  position: "absolute",
                  top: "29px",
                  right: "8px",
                }}
              >
                <AddButton
                  text="Add"
                  onClick={addNewUser}
                  baseTypeProps={{ disabled: props.isSaving }}
                />
              </div>
            ) : null}
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <UserSelectDetailList
            UserList={filteredUsers}
            onSelectionChanged={(users) => {
              setSelectedUsers(users);
            }}
          />
        </Grid.Row>
        <Grid.Row className="panel-buttons">
          <Grid.Col>
            <SaveButton
              text="Save"
              baseTypeProps={{
                disabled:
                  props.isSaving || !selectedUsers || selectedUsers.length < 1,
              }}
              onClick={assignUsers}
            />
          </Grid.Col>
          <Grid.Col>
            <CancelButton
              text="Cancel"
              onClick={onCancelForm}
              baseTypeProps={{ disabled: props.isSaving }}
            />
          </Grid.Col>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default NewUserForm;
